import React, { useState, useEffect } from "react";
import "../Styles/GridView.scss";
import { useDisclosure } from "@mantine/hooks";
import { Modal, Button, Progress, Menu } from "@mantine/core";
import { IconXboxX } from "@tabler/icons-react";
import img1 from "../../../../../assets/img/Rectangle 91.png";
import timer from "../../../../../assets/img/Images/timer.svg";
import ApiService from "../../../../../services/api";
import Image_Prefix from "../../../../../assets";
const GridCard = ({ data, index, trackerId }) => {
  const [opened, { open, close }] = useDisclosure(false);
  console.log("heredata", data);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [currentQuestionData, setCurrentQuestionData] = useState();
  const [selectedLanguage, setSelectedLanguage] = useState("English");
  const [visible, setVisible] = useState(0);

  console.log(data, "t678");
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await ApiService.getSubjectWiseQuestionDetails(
          trackerId,
          data?.questionCode,
          "en"
        );
        console.log(
          res?.data?.data?.question,
          "t561",
          currentQuestion.questionCode
        );
        if (res && res?.data && res?.data?.data) {
          setCurrentQuestionData(res?.data?.data);
        }
        // Perform other actions with the response if necessary
        // console.log("api called useres", res);
        // console.log("data for the Test report", res.data.data);
      } catch (err) {
        console.log(err);
        // fireToast("error", err.response.data.message, undefined, true);
      }
    };
    if (data?.questionCode && trackerId) {
      fetchData();
    }
  }, [trackerId, data?.questionCode]);

  console.log();

  const handleCurrentQuestion = () => {
    open();
    setCurrentSlide(index);
    // setCurrentQuestion(quescard);
  };
  return (
    <>
      <div className="GridCardWrapper">
        <div
          style={{
            backgroundColor:
              data?.attemptedOption?.optionLabel ==
              data?.correctOption?.optionId
                ? "#3CB371"
                : data?.attemptedOption?.optionLabel == "null"
                ? "#C0C0C0"
                : "#FE7970",
          }}
          className="bgdiv flexItemRow"
        >
          <div className="flexItemRow" style={{ columnGap: "1.5rem" }}>
            <div style={{ color: "white" }} className=" textdiv">
              Question {index + 1}
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="33"
              viewBox="0 0 32 33"
              fill="none"
            >
              <circle cx="16" cy="16.5" r="16" fill="white" />
              <path
                d="M24.5 10.91L12.5 22.91L7 17.41L8.41 16L12.5 20.08L23.09 9.5L24.5 10.91Z"
                fill="#3CB371"
              />
            </svg>
          </div>
          <div className="optiondiv">{data?.correctOption?.optionLabel}</div>
        </div>
        <div className="marksdiv">
          <div className="textdivi">
            Your Answer : {data?.attemptedOption?.optionLabel}{" "}
          </div>
          <div className="flexItemRow" style={{ columnGap: "12px" }}>
            <div className="textdiv2">Marks</div>
            <div
              style={{
                backgroundColor: "#3CB371",
                "border-radius": "10px",
                width: "40px",
                height: "20px",
                color: "white",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "10px",
              }}
            >
              {data?.markObtain}
            </div>
          </div>
          <div className="solutions" onClick={handleCurrentQuestion}>
            See Solution
          </div>
        </div>
        <div
          className="flexItemRow threedivs"
          style={{ columnGap: "0.5rem", justifyContent: "space-evenly" }}
        >
          <div
            className="flexItemCol"
            style={{
              backgroundColor: "#228BE6",
              transform: "rotate(0.072deg)",
              flexShrink: "0",
              padding: "0.5rem",
              paddingRight: "1rem",
              paddingLeft: "1rem",
              borderRadius: "6px",
            }}
          >
            <div
              className="flexItemRow"
              style={{
                color: "#FFF",
                fontFamily: "Montserrat",
                fontSize: "12px",
                fontStyle: "normal",
                fontWeight: "600",
                lineHeight: "normal",
              }}
            >
              {data?.timeTakenAvarageInSec} sec{" "}
            </div>
            <div
              className="flexItemRow"
              style={{
                color: "#FAFAFA",
                fontFamily: "Montserrat",
                fontSize: "12px",
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "normal",
              }}
            >
              You{" "}
            </div>
          </div>
          <div
            className="flexItemCol"
            style={{
              backgroundColor: "#3CB371",
              transform: "rotate(0.072deg)",
              flexShrink: "0",
              padding: "0.5rem",
              paddingRight: "1rem",
              paddingLeft: "1rem",
              borderRadius: "6px",
            }}
          >
            <div
              className="flexItemRow"
              style={{
                color: "#FFF",
                fontFamily: "Montserrat",
                fontSize: "12px",
                fontStyle: "normal",
                fontWeight: "600",
                lineHeight: "normal",
              }}
            >
              {data?.timeTakenTopperInSec} sec{" "}
            </div>
            <div
              className="flexItemRow"
              style={{
                color: "#FAFAFA",
                fontFamily: "Montserrat",
                fontSize: "12px",
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "normal",
              }}
            >
              Topper{" "}
            </div>
          </div>
          <div
            className="flexItemCol"
            style={{
              backgroundColor: "#C0C0C0",
              transform: "rotate(0.072deg)",
              flexShrink: "0",
              padding: "0.5rem",
              paddingRight: "1rem",
              paddingLeft: "1rem",
              borderRadius: "6px",
            }}
          >
            <div
              className="flexItemRow"
              style={{
                color: "#FFF",
                fontFamily: "Montserrat",
                fontSize: "12px",
                fontStyle: "normal",
                fontWeight: "600",
                lineHeight: "normal",
              }}
            >
              {data?.timeTakenAvarageInSec} sec{" "}
            </div>
            <div
              className="flexItemRow"
              style={{
                color: "#FAFAFA",
                fontFamily: "Montserrat",
                fontSize: "12px",
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "normal",
              }}
            >
              Avg{" "}
            </div>
          </div>
        </div>
        <div style={{ width: "100%" }}>
          <Modal
            opened={opened}
            onClose={close}
            size="60%"
            closeOnClickOutside={true}
            styles={{
              close: {
                backgroundColor: "black",
                color: "pink",
                position: "absolute",
                top: "-20px",
                right: "12px",
                ":hover": { backgroundColor: "red" },
              },
              header: {},
            }}
            closeButtonProps={{
              icon: <img src={img1} />,
            }}
            yOffset="0"
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <div
                className="questiondiv"
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {data?.questions?.map((quescard, index) => {
                  return (
                    <div
                      style={{
                        backgroundColor: !quescard?.isAttempted
                          ? "#C0C0C0C4"
                          : quescard?.isCorrect
                          ? "#FE7970x"
                          : "3CB371",
                        color: "white",
                        cursor: "pointer",
                      }}
                      onClick={() => handleCurrentQuestion(quescard, index)}
                      className="element"
                    >
                      {index + 1}
                    </div>
                  );
                })}

                <Menu
                  styles={{
                    dropdown: {
                      width: "325px",
                      backgroundColor: "",
                      borderRadius: "20px",
                    },
                  }}
                  shadow="md"
                  trigger="hover"
                >
                  <Menu.Target>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      {data?.questions?.length > 5 && (
                        <img src={Image_Prefix.tripledots} alt="" />
                      )}
                    </div>
                  </Menu.Target>

                  <Menu.Dropdown>
                    <Menu.Item>
                      <div className="MenuDots">
                        <div>Ques</div>
                        <div className="itemsgrid">
                          {data?.questions?.map((quescard, index) => {
                            return (
                              <div
                                style={{
                                  backgroundColor: !quescard?.isAttempted
                                    ? "#C0C0C0C4"
                                    : quescard?.isCorrect
                                    ? "#FE7970x"
                                    : "3CB371",
                                  color: "white",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  handleCurrentQuestion(quescard, index)
                                }
                                className="element"
                              >
                                {index + 1}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </Menu.Item>
                  </Menu.Dropdown>
                </Menu>
                {/* <div style={{ display: "flex", cursor: "pointer" }}>
                <img src={tripledots} alt="" />
              </div> */}
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  columnGap: "2rem",
                  marginTop: "1.5rem",
                }}
              >
                <div
                  style={{
                    backgroundColor: !currentQuestion?.isAttempted
                      ? "#C0C0C0C4"
                      : currentQuestion?.isCorrect
                      ? "#FE7970x"
                      : "3CB371",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={open}
                  className="element"
                >
                  {currentSlide + 1}
                </div>
                <div className="flexItemRow" style={{ marginLeft: "1rem" }}>
                  <img src={timer} alt="" />
                  <div
                    style={{
                      color: " #333",
                      fontFamily: "Montserrat",
                      fontSize: "16px",
                      fontStyle: "normal",
                      fontWeight: "500",
                      lineHeight: "normal",
                    }}
                  >
                    You-0:20
                  </div>
                </div>
                <div className="flexItemRow">
                  {/* <img src={timer} alt=""/>   */}
                  <div
                    style={{
                      color: " #333",
                      fontFamily: "Montserrat",
                      fontSize: "16px",
                      fontStyle: "normal",
                      fontWeight: "500",
                      lineHeight: "normal",
                    }}
                  >
                    Avg-0:20
                  </div>
                </div>
                <div className="flexItemRow">
                  {/* <img src={timer} alt=""/>   */}
                  <div
                    style={{
                      color: " #333",
                      fontFamily: "Montserrat",
                      fontSize: "16px",
                      fontStyle: "normal",
                      fontWeight: "500",
                      lineHeight: "normal",
                    }}
                  >
                    Topper-0:20
                  </div>
                </div>

                <div
                  style={{
                    borderRight: "1px solid gray ",
                    height: "1.4rem",
                    width: "1px",
                  }}
                ></div>
                <div className="flexItemRow" style={{ columnGap: "11px" }}>
                  <div>Marks</div>
                  <div
                    style={{
                      backgroundColor: "#3CB371",
                      "border-radius": "10px",
                      width: "40px",
                      height: "20px",
                      color: "white",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      fontSize: "10px",
                    }}
                  >
                    {data?.markObtain}
                  </div>
                  <div
                    style={{
                      backgroundColor: "#EB4343",
                      "border-radius": "10px",
                      width: "40px",
                      height: "20px",
                      color: "white",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      fontSize: "10px",
                    }}
                  >
                    -0.5
                  </div>
                </div>
                <div className="flexItemRow" style={{ columnGap: "11px" }}>
                  <div
                    className=""
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      justifyContent: "flex-end",
                      width: "100%",
                      paddingRight: "2rem",
                    }}
                  >
                    <span style={{ fontSize: "14px" }}>View In </span>
                    <select
                      name="selectedLanguage"
                      id="selectedLanguage"
                      value={selectedLanguage}
                      onChange={(e) => {
                        setSelectedLanguage(e.target.value);
                      }}
                      style={{
                        fontFamily: "'Figtree', sans-serif",
                        padding: "4px 10px",
                        boxSizing: "border-box",
                        borderRadius: "8px",
                        border: "1px solid #CED4DA",
                        background: "#DBF3FF",
                        cursor: "pointer",
                        outline: "none",
                      }}
                    >
                      <option value="English">English</option>
                      <option value="Hindi">Hindi</option>
                    </select>
                  </div>
                  {/* <div>View In</div>
                <div
                  style={{
                    border: "1px solid gray",
                    borderRadius: "5px",
                    paddingLeft: "5px",
                    paddingRight: "5px",
                  }}
                  className="flexItemRow"
                >
                  <div
                    style={{
                      backgroundColor: "",
                      "border-radius": "2px",
                      padding: "2px",
                      width: "fit-content",
                      height: "20px",
                      color: "black",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    English{" "}
                  </div>

                  <IconChevronLeft style={{ transform: "rotate(270deg)" }} />
                </div> */}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  columnGap: "2rem",
                  marginTop: "1.5rem",
                  flexDirection: "column",
                }}
              >
                <div
                  style={{
                    color: "#000",
                    fontFamily: "Montserrat",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: "600",
                    lineHeight: "normal",
                    marginLeft: "63px ",
                    marginRight: "42px",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: currentQuestionData?.question?.question?.text,
                  }}
                >
                  {/* Directions: In the following sentence, a part of the sentence is
                underlined.Below are given alternatives to the underlined part,
                which may improve the sentence. Choose the correct alternative.
                In case no improvement is needed, choose the alternative that
                indicates 'No improvement'. */}
                </div>
                {/* <div
                style={{
                  color: "#000",
                  fontFamily: "Montserrat",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: "400",
                  lineHeight: "normal",
                  display: "flex",
                  justifyContent: "flex-start",
                  marginLeft: "63px ",
                  marginRight: "auto",
                  marginTop: "1.5rem",
                }}
              >
                Mrs. Kavitha is eclipsed by her husband who is much livelier and
                more intelligent than she is.
              </div> */}
                {currentQuestionData?.question?.options.map((option, index) => (
                  <div
                    key={option._id}
                    className="flexItemRow"
                    style={{
                      marginLeft: "63px ",
                      alignItems: "center",
                      columnGap: "0.8rem",
                      marginTop: "1rem",
                    }}
                  >
                    <input
                      type="radio"
                      name="option"
                      style={{
                        width: "24px",
                        height: "24px",
                        "accent-color": option.isCorrect
                          ? "#3CB371"
                          : "#FE7970",
                      }}
                      disabled
                      value={option.optionId}
                    />
                    <div
                      dangerouslySetInnerHTML={{ __html: option.option.text }}
                    ></div>
                    {option.isCorrect &&
                      currentQuestionData?.question?.checkedAnswerId ==
                        currentQuestionData?.question?.correctAnswerId && (
                        <div
                          className="flexItemRow"
                          style={{
                            backgroundColor: "#3CB371",
                            color: "white",
                            display: "inline-flex",
                            padding: "10px",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "8px",
                            borderRadius: "15px",
                          }}
                        >
                          <div>Correct Answer</div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                          >
                            <path
                              d="M17.5003 5.8332L7.50033 15.8332L2.91699 11.2499L4.09199 10.0749L7.50033 13.4749L16.3253 4.6582L17.5003 5.8332Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                      )}

                    {!option.isCorrect &&
                      currentQuestionData?.question?.checkedAnswerId ==
                        option?.optionId && (
                        <div
                          className="flexItemRow"
                          style={{
                            backgroundColor: "#FE7970",
                            color: "white",
                            display: "inline-flex",
                            padding: "10px",
                            justifyContent: "end",
                            alignItems: "center",
                            gap: "8px",
                            borderRadius: "15px",
                            minWidth: "160px",
                          }}
                        >
                          <div>Your Answer</div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                          >
                            <path
                              d="M16.6663 16.6668L3.33301 3.3335M16.6663 3.3335L3.33301 16.6668"
                              stroke="white"
                              stroke-width="2"
                              stroke-linecap="round"
                            />
                          </svg>
                        </div>
                      )}
                  </div>
                ))}
                {/* <div
                className="flexItemRow"
                style={{
                  marginLeft: "63px ",
                  alignItems: "center",
                  columnGap: "0.8rem",
                  marginTop: "1rem",
                }}
              >
                <input
                  type="radio"
                  name=""
                  style={{
                    width: "24px",
                    height: " 24px",
                    // backgroundColor: "#FE7970",
                    // color: "#FE7970",
                    "accent-color": "#3CB371",
                  }}
                  value=""
                />
                <div>Much lively and more intelligent</div>
                <div
                  className="flexItemRow"
                  style={{
                    backgroundColor: "#FE7970",
                    color: "white",
                    display: "inline-flex",
                    padding: "10px",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "8px",
                    borderRadius: "15px",
                    minWidth:"160px"
                  }}
                >
                  <div>Your Answer</div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M16.6663 16.6668L3.33301 3.3335M16.6663 3.3335L3.33301 16.6668"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                  </svg>
                </div>
              </div> */}
                {/*  <div
                className="flexItemRow"
                style={{
                  marginLeft: "63px ",
                  alignItems: "center",
                  columnGap: "0.8rem",
                  marginTop: "1rem",
                }}
              >
                <input
                  type="radio"
                  name=""
                  style={{
                    width: "24px",
                    height: " 24px",
                    backgroundColor: "#FE7970",
                    color: "#FE7970",
                  }}
                  value=""
                />
                <div>Much lively and more intelligent</div>
              <div
                  className="flexItemRow"
                  style={{
                    backgroundColor: "#FE7970",
                    color: "white",
                    display: "inline-flex",
                    padding: "10px",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "8px",
                    borderRadius: "15px",
                  }}
                >
                  <div>Your Answer</div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M16.6663 16.6668L3.33301 3.3335M16.6663 3.3335L3.33301 16.6668"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                  </svg>
                </div> 
              </div>*/}
                {/* <div
                className="flexItemRow"
                style={{
                  marginLeft: "63px ",
                  alignItems: "center",
                  columnGap: "0.8rem",
                  marginTop: "1rem",
                }}
              >
                <input
                  type="radio"
                  name=""
                  style={{
                    width: "24px",
                    height: " 24px",
                    // backgroundColor: "#FE7970",
                    // color: "#FE7970",
                    "accent-color": "#FE7970",
                  }}
                  value=""
                />
                <div>Much lively and more intelligent</div>
                <div
                  className="flexItemRow"
                  style={{
                    backgroundColor: "#3CB371",
                    color: "white",
                    display: "inline-flex",
                    padding: "10px",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "8px",
                    borderRadius: "15px",
                  }}
                >
                  <div>Correct Answer</div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M17.5003 5.8332L7.50033 15.8332L2.91699 11.2499L4.09199 10.0749L7.50033 13.4749L16.3253 4.6582L17.5003 5.8332Z"
                      fill="white"
                    />
                  </svg>
                </div>
              </div> */}
                {/* <div
                className="flexItemRow"
                style={{
                  marginLeft: "63px ",
                  alignItems: "center",
                  columnGap: "0.8rem",
                  marginTop: "1rem",
                }}
              >
                <input
                  type="radio"
                  name=""
                  style={{
                    width: "24px",
                    height: " 24px",
                    backgroundColor: "#FE7970",
                    color: "#FE7970",
                  }}
                  value=""
                />
                <div>Much lively and more intelligent</div>
             
              </div> */}

                <div
                  style={{
                    color: "#000",

                    display: "flex",
                    justifyContent: "flex-start",
                    marginLeft: "63px ",
                    marginRight: "auto",
                    marginTop: "1.5rem",
                  }}
                >
                  <span
                    style={{
                      color: "#000",
                      fontFamily: "Montserrat",
                      fontSize: "16px",
                      fontStyle: "normal",
                      fontWeight: "500",
                      lineHeight: "normal",
                    }}
                  >
                    The correct answer is ‘D’ -
                  </span>
                  <span
                    style={{
                      color: "#000",
                      fontFamily: "Montserrat",
                      fontSize: "16px",
                      fontStyle: "normal",
                      fontWeight: "400",
                      lineHeight: "normal",
                    }}
                  >
                    Much lively and more intelligent
                  </span>
                </div>
                <div
                  style={{
                    color: "#000",
                    fontFamily: "Montserrat",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: "400",
                    lineHeight: "normal",
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    marginLeft: "63px ",
                    marginRight: "auto",
                    marginTop: "1.5rem",
                  }}
                >
                  {/* <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M8.56627 5.96024C8.49475 5.46759 8.53007 4.96531 8.66983 4.48751C8.80959 4.00971 9.05052 3.56758 9.37627 3.19113C9.70201 2.81468 10.1049 2.51273 10.5577 2.30577C11.0105 2.09881 11.5025 1.9917 12.0003 1.9917C12.4981 1.9917 12.9901 2.09881 13.4428 2.30577C13.8956 2.51273 14.2985 2.81468 14.6243 3.19113C14.95 3.56758 15.191 4.00971 15.3307 4.48751C15.4705 4.96531 15.5058 5.46759 15.4343 5.96024L14.2823 14.0202C14.2025 14.5686 13.928 15.0699 13.509 15.4324C13.0899 15.7949 12.5544 15.9944 12.0003 15.9944C11.4462 15.9944 10.9106 15.7949 10.4916 15.4324C10.0725 15.0699 9.79801 14.5686 9.71827 14.0202L8.56627 5.96024ZM14.0003 20.0002C14.0003 20.5307 13.7896 21.0394 13.4145 21.4145C13.0394 21.7895 12.5307 22.0002 12.0003 22.0002C11.4698 22.0002 10.9611 21.7895 10.5861 21.4145C10.211 21.0394 10.0003 20.5307 10.0003 20.0002C10.0003 19.4698 10.211 18.9611 10.5861 18.586C10.9611 18.211 11.4698 18.0002 12.0003 18.0002C12.5307 18.0002 13.0394 18.211 13.4145 18.586C13.7896 18.9611 14.0003 19.4698 14.0003 20.0002Z"
                    fill="black"
                  />
                </svg>{" "} */}
                  {/* <div
                  style={{
                    color: "#000",
                    fontFamily: "Montserrat",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: "600",
                    lineHeight: "normal",
                  }}
                >
                  Important points
                </div> */}
                </div>
                {/* <div
                style={{
                  color: "#000",
                  fontFamily: "Montserrat",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: "400",
                  lineHeight: "normal",
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  marginLeft: "73px ",
                  marginRight: "auto",
                }}
              >
                <ul style={{ listStyleType: "disc", marginLeft: "1rem" }}>
                  <li>Lorem ipsum dolor sit amet.</li>
                  <li>Lorem ipsum dolor sit amet.</li>
                  <li>Lorem ipsum dolor sit amet.</li>
                  <li>Lorem ipsum dolor sit amet.</li>
                  <li>Lorem ipsum dolor sit amet.</li>
                </ul>
              </div> */}
                <div
                  style={{
                    color: "#000",

                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    marginLeft: "73px ",
                    marginRight: "auto",
                    width: "90%",
                  }}
                >
                  <div
                    style={{
                      display: "inline-flex",
                      padding: "10px 20px",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "10px",
                      borderRadius: "5px",
                      border: "1px solid  #333",
                      boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.20)",
                    }}
                  >
                    Submit Feedback
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default GridCard;
